export var SEARCH_ICON_CLASS_PREFIX = 'SearchIcon';